import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="renteneintritt"
export default class extends Controller {
	static values = {
		geburtsjahr: Number,
		geburtsmonat: Number,
	}

	static targets = ["label"]

	connect() {
		// Action im hidden Field des Datums setzen
		const inputDatum = this.element.querySelector("input[type=hidden][data-datum-target]")
		if (inputDatum) inputDatum.dataset.action = "change->renteneintritt#updateLabel"
	}

	updateLabel({ currentTarget }) {
		const renteneintritt = currentTarget.value.split("-")
		const rentenjahr = parseInt(renteneintritt[0])
		const rentenmonat = parseInt(renteneintritt[1])

		let alter = rentenjahr - this.geburtsjahrValue
		if (rentenmonat < this.geburtsmonatValue) alter--

		if (alter < 0 || alter > 150) alter = 0

		this.labelTarget.innerHTML = `Renteneintritt (mit ${alter})`
	}
}
